/**
 * account模块接口列表
 */
import $http from "../utils/http"; // 导入http中创建的axios实例

const account = {
  // 账户创建
  createAccount(params) {
    return $http.post(`${global.API_URL}/sme/account/create`, params);
  },
  // 立即扫描资源
  scanResource(params) {
    return $http.post(`${global.API_URL}/sme/account/scanResource`, params);
  },
  // 更新
  updateScan(params) {
    return $http.post(`${global.API_URL}/sme/account/updateScan`, params);
  },
  // 扫描资源切换
  changeScanResources(params) {
    return $http.post(
      `${global.API_URL}/sme/account/changeScanResources`,
      params
    );
  },
  // 编辑账户
  updateAccount(params) {
    return $http.post(`${global.API_URL}/sme/account/update`, params);
  },
  //账户列表分页
  pageAccount(params) {
    return $http.post(`${global.API_URL}/sme/account/page`, params);
  },
  //账户删除
  deleteAccount(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/delete`, param);
  },
  //根据用户名获取扫描配置
  selectScanByCompanyId(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/selectScanByCompanyId`,
      param
    );
  },
  //根据id查询account
  selectAccount(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/select`, param);
  },
  //根据用户名查询account
  selectByName(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/selectByName`, param);
  },
  //根据用户名查询Account列表
  selectAccountByUserName(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryAccountsByUsername`,
      param
    );
  },
  // 验证AccessKey
  validCredential(params) {
    return $http.post(`${global.API_URL}/sme/account/validCredential`, params);
  },
  //查询Account下拉框
  queryAccounts(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/queryAccounts`, param);
  },
  //查询Account下拉框
  queryAccountsByCompanyId(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryAccountsByCompanyId`,
      param
    );
  },
  //查询当前用户下所有地区
  queryAccountRegions(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryAccountRegions`,
      param
    );
  },
  //根据账号类型查询负载均衡类型
  listLoadBalancerTypes(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/loadBalancer/listLoadBalancerTypes`,
      param
    );
  },
  //根据账户id显示获取账户类型
  getAccountTypeByAccountId(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/getAccountTypeByAccountId`,
      param
    );
  },
  //根据账号类型地区查询区域
  queryRegionsByAccount(params) {
    return $http.post(
      `${global.API_URL}/sme/account/queryRegionsByAccount`,
      params
    );
  },
  //查询地区
  queryRegions(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/queryRegions`, param);
  },
  //云平台下拉框
  queryCloudPlatforms(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryCloudPlatforms`,
      param
    );
  },
  //云平台下拉框
  queryCloudPlatformsMSP(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryCloudPlatformsMSP`,
      param
    );
  },
  //查询当前用户下绑定的账户 查询云平台下拉框
  queryCloudPlatformsByCurrentUser(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryCloudPlatformsByCurrentUser`,
      param
    );
  },
  //查询云平台下所有账号
  selectAccountByCloudPlatform(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/selectAccountByCloudPlatform`,
      param
    );
  },
  //查询云平台下所有账号
  selectAccountByType(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/selectAccountByType`,
      param
    );
  },
  //查询账户集合
  queryAccountList(params) {
    return $http.post(`${global.API_URL}/sme/account/queryAccountList`, params);
  },
  //删除账户组下账户
  deleteByAccountGroup(params) {
    return $http.post(
      `${global.API_URL}/sme/account/deleteByAccountGroup`,
      params
    );
  },
  //根据云平台类型和地区类型查询账户列表
  listAccountByCloudPlatformAndAreaType(params) {
    return $http.post(
      `${global.API_URL}/sme/account/listAccountByCloudPlatformAndAreaType`,
      params
    );
  },
  //账号重复绑定验证
  accountRepeatAddCheck(params) {
    return $http.post(
      `${global.API_URL}/sme/account/accountRepeatAddCheck`,
      params
    );
  },
  //查询AWSAccount下拉框
  queryAWSAccounts(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/queryAWSAccounts`, param);
  },
  queryAWSCloudAccounts(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/queryAWSCloudAccounts`, param);
  },
  //查询当前公司下所有aws账户
  getAWSAccountByCompanyId(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/getAWSAccountByCompanyId`,
      param
    );
  },
  //根据公司ID查询账户
  queryAccountListByCompanyIdAndCloudType(params) {
    return $http.post(
      `${global.API_URL}/sme/account/queryAccountListByCompanyIdAndCloudType`,
      params
    );
  },
  // 根据账号id查询公司id
  getCompanyIdByAccountId(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/getCompanyIdByAccountId`,
      param
    );
  },
  //获取AWS账户下策略一览
  getAWSAccountPermissionStatistics(params) {
    return $http.post(
      `${global.API_URL}/sme/account/getAWSAccountPermissionStatistics`,
      params
    );
  },
  // 查询账号
  inquireAccount(params) {
    return $http.post(`${global.API_URL}/sme/account/inquireAccount`, params);
  },
  //导出AWS账户下策略一览Excel
  exportAWSAccountPermissionStatistics(params) {
    return $http.post(
      `${global.API_URL}/sme/account/exportAWSAccountPermissionStatistics`,
      params,
      {
        responseType: "arraybuffer",
        timeout: 1000 * 60 * 5
      }
    );
  },
  // 根据账号id查询区域
  queryAccountRegionsByAccountIds(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryAccountRegionsByAccountIds`,
      param
    );
  },
  // 账号列表
  listAccountsByCompanyIdAndCloudPlatformType(params) {
    return $http.post(
      `${global.API_URL}/sme/account/listAccountsByCompanyIdAndCloudPlatformType`,
      params
    );
  },
  // 预留实例账号列表
  listAccountsByCompanyIdsAndCloudPlatformType(params) {
    return $http.post(
      `${global.API_URL}/sme/account/listAccountsByCompanyIdsAndCloudPlatformType`,
      params
    );
  },
  //账号附件删除
  deleteSecretFile(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/account/deleteSecretFile`, param);
  },
  //查询账号关联区域信息
  queryRegionsByAccounts(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryRegionsByAccounts`,
      param
    );
  },
  //查询当前公司下所有ali账户
  getAliyunAccountByCompanyId(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/getAliyunAccountByCompanyId`,
      param
    );
  },
  //查询当前公司下所有gcp账户
  queryGCPAccountBox(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryGCPAccountBox`,
      param
    );
  },
  //查询Account下拉框
  queryAccountsByCloudType(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryAccountsByCloudType`,
      param
    );
  },
  // 查询所有云平台
  queryCloudList() {
    return $http.get(`${global.API_URL}/sme/account/getCloudType`)
  },
  queryAuthenticationType(cloudType) {
    return $http.get(`${global.API_URL}/sme/account/getAuthenticationType?cloudType=${cloudType}`)
  },
  //查询当前公司下所有华为云账户
  queryHWCAccountBox(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryHuaweiAccountBox`,
      param
    );
  },
  //查询当前公司下所有腾讯云账户
  queryTencentAccountBox(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(
      `${global.API_URL}/sme/account/queryTencentAccountBox`,
      param
    );
  },
  // 账号名称校验
  accountNameCheck(params) {
    return $http.post(
      `${global.API_URL}/sme/account/accountNameRepeatAddCheck`,
      params
    );
  },
};

export default account;



// WEBPACK FOOTER //
// ./src/api/account.js